import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-received-lp-form',
  templateUrl: './project-received-lp-form.component.html',
  styleUrls: ['./project-received-lp-form.component.css']
})
export class ProjectReceivedLpFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/planning/project-received-land-pro-details/project-received-lp-form/project-received-lp-form.component.ts